import morph from "../helpers/morph";
import {
  applyCollectionFilter,
  carryCollectionFilterParams,
} from "../helpers/collectionFilter";

class ProductPageMorph extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("variant:changed", (e) => {
      this.renderedVariantId = this.getAttribute("rendered-variant-id");
      const { variant } = e.detail;

      if (!variant || variant.id === this.renderedVariantId) return;

      const variantUrl = new URL(
        window.productUrl(variant.product.handle),
        window.location.origin,
      );

      variantUrl.searchParams.set("variant", window.gidToId(variant.id));

      if (this.morph === "self") {
        variantUrl.searchParams.set("section_id", this.sourceSectionId);
        variantUrl.searchParams.set("view", "add-on");
      }

      this.updateContent(variantUrl);
      this.renderedVariantId = variant.id;
    });
  }

  connectedCallback() {}

  disconnectedCallback() {}

  updateContent(url) {
    const mainContentSelector = "#MainContent";
    const sourceSelector =
      this.morph === "page" ? mainContentSelector : "product-page-morph";

    fetch(url)
      .then((res) => res.text())
      .then((text) => {
        const section = new DOMParser().parseFromString(text, "text/html");
        const targetEl = document
          .createRange()
          .createContextualFragment(
            section.querySelector(sourceSelector).outerHTML,
          );

        applyCollectionFilter(targetEl, this.collectionFilter);

        if (this.updateUrl) {
          url.searchParams.delete("section_id");

          // The stock filter reads these off the page URL, so a reload or a
          // shared link still opens on it.
          carryCollectionFilterParams(window.location.search, url);

          window.history.replaceState("", "", url);
          document.title = section.title;
        }

        const target =
          this.morph === "page"
            ? document.querySelector(mainContentSelector)
            : this;

        morph(target, targetEl);
      });
  }

  get sourceSectionId() {
    return this.getAttribute("source-section-id");
  }

  get updateUrl() {
    return !window.Shopify.designMode && this.hasAttribute("update-url");
  }

  /** Set by applyCollectionFilter where the page URL doesn't carry one */
  get collectionFilter() {
    return this.getAttribute("collection-filter");
  }

  get morph() {
    return this.getAttribute("morph") || "page";
  }
}

if (!customElements.get("product-page-morph")) {
  customElements.define("product-page-morph", ProductPageMorph);
}
